/**
 * Demo-only: restrict catalog to selected SKUs and show MTR-style labels in the UI.
 * Backend calls still use real model_code values (SKU strings).
 */

export const DEMO_PRODUCT_MODEL_CODES = [
  "LAVA_SHARK2",
  "LF7002_A7_TORCH",
  "YUVA_SMART_2",
  "SHARK_5G_4+128",
];

const DEMO_MODEL_TO_DISPLAY_NAME = {
  LAVA_SHARK2: "MTR Puliogare Mix",
  LF7002_A7_TORCH: "MTR Gulab Jamun Mix",
  YUVA_SMART_2: "MTR Rava Idli Mix",
  "SHARK_5G_4+128": "MTR Upma Mix",
};

/** Representative food imagery for demo (Unsplash, free to use). Replace with brand assets if needed. */
const DEMO_MODEL_IMAGE_URL = {
  YUVA_SMART_2:
    "https://shop.orklaindia.com/cdn/shop/files/1_3476f558-2d98-47b1-94c9-fb7696d45062.png?v=1756198587&width=1000",
  "SHARK_5G_4+128":
    "https://shop.orklaindia.com/cdn/shop/files/1_e236d0be-d2b8-4307-9fd4-5ecec6f0be3b.png?v=1756199782&width=1000",
  LAVA_SHARK2:
    "https://shop.orklaindia.com/cdn/shop/files/1_2c33fde5-d4c9-49cb-ac53-1aa03b26482b.png?v=1756185241&width=1000",
  LF7002_A7_TORCH:
    "https://shop.orklaindia.com/cdn/shop/files/MTR_Gulab_jamun_mix_175g_FOP.jpg?v=1756203681&width=1000",
};

const DEMO_CATEGORY_TO_DISPLAY_NAME = {
  FP: "MTR Breakfast Mixes",
  SP: "MTR Instant Mixes",
  Accessories: "MTR Kitchen Essentials",
  "Moto-FP": "MTR Value Packs",
  Others: "MTR Specials",
};

const DEMO_FAMILY_TO_DISPLAY_NAME = {
  SHARK: "MTR Savoury Mixes",
  TORCH: "MTR Dessert Mixes",
  YUVA: "MTR Daily Mixes",
};

export function filterDemoProductsForList(rawData) {
  if (!Array.isArray(rawData)) return rawData;
  const allow = new Set(DEMO_PRODUCT_MODEL_CODES);
  return rawData.filter((row) => allow.has(row.model_code));
}

export function isDemoProductSku(code) {
  if (code == null || code === "") return false;
  return DEMO_PRODUCT_MODEL_CODES.includes(String(code));
}

export function demoProductImageUrl(modelCode) {
  if (modelCode == null) return null;
  return DEMO_MODEL_IMAGE_URL[String(modelCode)] ?? null;
}

/** Models to show thumbnails for: single SKU, or all demo SKUs under a selected category. */
export function getDemoModelsForRightPanel(selectedItemName, sopData) {
  if (!selectedItemName) return [];
  if (isDemoProductSku(selectedItemName)) {
    return [String(selectedItemName)];
  }
  const groups = sopData?.[selectedItemName];
  if (!groups || !Array.isArray(groups)) return [];
  const fromTree = [...new Set(groups.flatMap((g) => g.models || []))];
  return fromTree.filter((mc) => isDemoProductSku(mc));
}

/** Use for any UI string that should show the demo retail name instead of the internal SKU. */
export function displayProductLabel(modelCodeOrKey) {
  if (modelCodeOrKey == null || modelCodeOrKey === "") return modelCodeOrKey;
  const key = String(modelCodeOrKey);
  return DEMO_MODEL_TO_DISPLAY_NAME[key] ?? modelCodeOrKey;
}

export function displayCategoryLabel(categoryName) {
  if (!categoryName) return categoryName;
  const key = String(categoryName);
  return DEMO_CATEGORY_TO_DISPLAY_NAME[key] ?? key;
}

export function displayFamilyLabel(familyName) {
  if (!familyName) return familyName;
  const key = String(familyName).trim().toUpperCase();
  return DEMO_FAMILY_TO_DISPLAY_NAME[key] ?? "MTR Signature Mixes";
}
